module.exports = __webpack_public_path__ + "static/media/Transportation-Insight-logo.5ec734e2.svg";